// De lo que manda la API (hechos) al cuadro resuelto (derivado). Igual que
// vistaGrupos.ts: la usan la web, para dibujarlo, y el Worker, para saber
// quiénes juegan un partido antes de aceptarle un resultado.

import { resolverCuadro, type CuadroResuelto, type Lugar, type PartidoDeCuadro } from './cuadro';
import { conTabla, marcadorDeFila, type GrupoGuardado, type PartidoGuardado } from './vistaGrupos';

export interface LugarGuardado {
  tipo: 'grupo' | 'pareja' | 'libre';
  grupo_id: number | null;
  puesto: number | null;
  pareja_id: number | null;
}

/** Un partido de cuadro como viaja en la API: `ronda` '1', '2'...; `orden` = posición en la ronda. */
export type PartidoDeCuadroGuardado = PartidoGuardado & { ronda: string | null };

export interface CuadroGuardado {
  lugares: LugarGuardado[];
  partidos: PartidoDeCuadroGuardado[];
}

function aLugar(l: LugarGuardado): Lugar {
  if (l.tipo === 'grupo' && l.grupo_id !== null && l.puesto !== null) return { tipo: 'grupo', grupo: l.grupo_id, puesto: l.puesto };
  if (l.tipo === 'pareja' && l.pareja_id !== null) return { tipo: 'pareja', pareja: l.pareja_id };
  return { tipo: 'libre' };
}

export function aPartidoDeCuadro(p: PartidoDeCuadroGuardado): PartidoDeCuadro {
  return { id: p.id, ronda: Number(p.ronda), pos: p.orden, marcador: marcadorDeFila(p), pareja_a: p.pareja_a, pareja_b: p.pareja_b };
}

/**
 * Los clasificados de cada grupo salen de su tabla: solo con el grupo
 * terminado y sin sorteo pendiente (si no, ese lugar del cuadro sigue diciendo
 * "1º Grupo A").
 */
export function resolverCuadroGuardado(
  cuadro: CuadroGuardado,
  grupos: readonly GrupoGuardado[],
  dadasDeBaja: ReadonlySet<number>,
  pasan: number,
): CuadroResuelto {
  const clasificados = new Map(grupos.map((g) => [g.id, conTabla(g, dadasDeBaja, pasan).tabla.clasificados]));
  return resolverCuadro(cuadro.lugares.map(aLugar), cuadro.partidos.map(aPartidoDeCuadro), clasificados, dadasDeBaja);
}
